<template>
    <div class="home pt-3">
        <b-breadcrumb>
            <b-breadcrumb-item active class="align-middle">
                <b-icon icon="house-fill" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                {{ $t("breadcrumb.linhas") }}
            </b-breadcrumb-item>
            <b-button variant="secondary" @click="showModalNovoLinha()" class="ml-auto" size="sm">
                <b-icon-plus />{{ $t('botoes.novo-linha') }}
            </b-button>
        </b-breadcrumb>


        <b-card class="mt-3" no-body>
            <b-table :items="linhas" :fields="fields" responsive="sm" head-variant="light" sort-icon-left striped
                :current-page="currentPage" :per-page="perPage" hover show-empty class="mb-0" :emptyText="$t('global.table-empty')">
                <template #cell(Ações)="row">
                    <b-button size="sm" @click="showModalLinha(row.item)" variant="primary" class="mr-1">
                        <b-icon icon="pencil-fill"></b-icon> {{ $t('botoes.editar') }}
                    </b-button>
                </template>
            </b-table>
        </b-card>
        <b-row align-h="center" class="my-3">
            <b-col sm="5" md="2" class="my-1">
                <b-form-group>
                    <b-form-select id="per-page-select" v-model="perPage" :options="pageOptions" size="sm">
                    </b-form-select>
                </b-form-group>
            </b-col>

            <b-col sm="7" md="2" class="my-1">
                <b-pagination v-model="currentPage" :total-rows="linhas.length" :per-page="perPage" align="fill"
                    size="sm" class="my-0"></b-pagination>
            </b-col>
        </b-row>
        <modal-carregando-geral />
        <modal-linha @listaMudou="carregarLinhas()" :linha="linha" />
    </div>
</template>

<script>
import ModalCarregandoGeral from "@/components/modal/CarregandoGeral.vue";
import ModalLinha from "@/components/modal/Linha.vue";
export default {
    name: "Linhas",
    components: {
        ModalCarregandoGeral,
        ModalLinha
    },
    data() {
        return {
            linha: {
                id: null,
                descricao: null,
                Inicio: null,
                Fim: null,
            },
            linhas: [],
            fields: [
                { key: "descricao", sortable: true },
                { key: "Ações", label: this.$t('table.title.acoes'), sortable: false, class: 'text-right' },
            ],
            totalRows: 1,
            currentPage: 1,
            perPage: 15,
            pageOptions: [
                { value: 5, text: this.$t('paginacao.5-itens-por-pagina') },
                { value: 10, text: this.$t('paginacao.10-itens-por-pagina') },
                { value: 15, text: this.$t('paginacao.15-itens-por-pagina') },
                { value: 100, text: this.$t('paginacao.100-itens-por-pagina') },
            ],
        };
    },
    methods: {
        showModalNovoLinha() {
            this.linha = {
                id: null,
                descricao: null,                
                diretorio_programa_winfas: null,                
                host_sql_winfas: null,                
                usuario_sql_winfas: null,                
                senha_sql_winfas: null,              
            };
            this.$bvModal.show("modal-linha");
        },
        showModalLinha(item) {

            this.linha = {
                id: item.id,
                descricao: item.descricao,                
                diretorio_programa_winfas: item.diretorio_programa_winfas,                
                host_sql_winfas: item.host_sql_winfas,                
                usuario_sql_winfas: item.usuario_sql_winfas,                
                senha_sql_winfas: item.senha_sql_winfas,                
            };
            this.$bvModal.show("modal-linha");
        },
        carregarLinhas() {
            this.$bvModal.show("modal-carregando-geral");
            this.$http
                .get("api/linha")
                .then((response) => {
                    this.linhas = response.data
                    this.$bvModal.hide("modal-carregando-geral");
                })
                .catch((errors) => {
                    console.log(errors);
                    this.$bvModal.hide("modal-carregando-geral");
                });
        },
    },
    mounted() {
        this.carregarLinhas()
    }
};
</script>

<style>

</style>